import React from 'react'
import { text } from '../utils/constants'
import { DelegateConnectWalletOptions } from './connectWallet/DelegateConnectWalletOptions'

function DelegateConnectWallet() {
    return (
        <div className="flex items-center justify-center w-full h-auto xsm:h-full md:px-4 forMobile">
            <div className="max-w-[1200px] w-full bg-[#121212] border border-[#1A1A1ACC] rounded-3xl pt-6 pb-11 md:py-10 px-4 md:px-9 mx-auto">
                <div className='grid lg:grid-cols-2 gap-8'>
                    <div className="flex flex-col gap-3 items-center md:items-start text-center md:text-left">
                        <h4 className="text-textcolor text-xxl md:text-[34px] leading-none font-bold md:font-semibold capitalize">
                            Connect your wallet
                        </h4>
                        <p className="text-xsm md:text-sm font-normal text-dim/50 max-w-[350px]">
                            {text.WALLET}
                        </p>
                    </div>

                    <ul className="space-y-3">
                        <DelegateConnectWalletOptions iconCustomClass="mr-3 lg:mr-4 w-6 h-6 md:w-8 md:h-8" />
                    </ul>
                </div>
            </div>
        </div >
    )
}

export default DelegateConnectWallet
